import { createContext, useContext, useEffect, useState } from "react"
import GetPriceMarkupGroupList from "../../api-layer/price-markup-group-api/GetPriceMarkupGroupList";

const PriceMarkupGroupContext = createContext();


const PriceMarkupGroupProvider = ({children}) => {
    const [priceMarkupGroups, setPriceMarkupGroups] = useState([]);

    useEffect(() => {
        getPriceMarkupGroups();
    },[
    ]);

    const getPriceMarkupGroups = () => {
        GetPriceMarkupGroupList('ordinary').then(
            res => {
                setPriceMarkupGroups(res.data);
            }
        ).catch(
            error => {
            }
        );
    }

    return (
        <PriceMarkupGroupContext.Provider
            value={{
                priceMarkupGroups,
            }}
        >
            {children}
        </PriceMarkupGroupContext.Provider>
    );
}
export default PriceMarkupGroupProvider;

export const usePriceMarkupGroup = () => {
    const context = useContext(PriceMarkupGroupContext);
    return context;
}
